import { render, staticRenderFns } from "./userActives.vue?vue&type=template&id=e2f91e54"
import script from "./userActives.vue?vue&type=script&lang=js"
export * from "./userActives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports